import React from 'react';
import PropTypes from 'prop-types';

import MenuVoicebotAudios from '../MenuVoicebotAudios';
import MenuVariaveisVoicebot from '../MenuVariaveisVoicebot';

import { Wrapper } from './styles';

const MenuWrapper = ({
  onSelect,
  id,
  hasAudioMenu = true,
  hasVariableMenu = true,
}) => {
  return (
    <Wrapper>
      {hasAudioMenu && <MenuVoicebotAudios onSelect={onSelect} id={id} />}
      {hasVariableMenu && <MenuVariaveisVoicebot onSelect={onSelect} />}
    </Wrapper>
  );
};

MenuWrapper.propTypes = {
  onSelect: PropTypes.func.isRequired,
};

export default MenuWrapper;
